import type { Plugin } from './plugin'

/**
 * Selectors for the Lab Service's Auto Lab Based functionalizations state.
 */
export class Selectors {
  /** Selector indicating if the data is being loaded from the backend */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly isLoading

  /** Calculated (Auto Lab Based) functionalizations */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly functionalizations

  /** Selector indicating if there was an error while fetching */
  // NOTE: Intentionally not typed here so that type can be inferred
  public readonly error

  constructor(plugin: Plugin) {
    this.isLoading = plugin.feature.state.project(state => state.isLoading)
    this.functionalizations = plugin.feature.state.project(
      state => state.functionalizations,
    )
    this.error = plugin.feature.state.project(state => state.error)
  }
}
